export default function PDFFooter() {
  return (
    <div id="footer" className="page-footer print-only">
      © {new Date().getFullYear()} Revere: Brand Luminaire. All rights reserved.
    </div>
  );
}
